import Vue from 'vue'
import { URL_INCOTERMS } from '@/constants/urls'
import { INCOTERMS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [INCOTERMS_MANAGEMENT.STATE.INCOTERMS]: null
}

const actions = {
  async [INCOTERMS_MANAGEMENT.ACTIONS.GET_INCOTERMS] ({ dispatch, commit }) {
    const model = {
      url: `${Vue.getBusinessHost()}${URL_INCOTERMS}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(INCOTERMS_MANAGEMENT.MUTATIONS.GET_INCOTERMS, resp.data)
  },
  async [INCOTERMS_MANAGEMENT.ACTIONS.ADD_INCOTERM] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_INCOTERMS}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [INCOTERMS_MANAGEMENT.ACTIONS.EDIT_INCOTERM] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_INCOTERMS}/${model.incotermId}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [INCOTERMS_MANAGEMENT.ACTIONS.DELETE_INCOTERM] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_INCOTERMS}/${model.incotermId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [INCOTERMS_MANAGEMENT.ACTIONS.ADD_COUNTRY] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_INCOTERMS}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [INCOTERMS_MANAGEMENT.ACTIONS.CLEAR_INCOTERMS] ({ commit }) {
    commit(INCOTERMS_MANAGEMENT.MUTATIONS.CLEAR_INCOTERMS)
  }
}

const mutations = {
  [INCOTERMS_MANAGEMENT.MUTATIONS.GET_INCOTERMS] (state, model) {
    state[INCOTERMS_MANAGEMENT.STATE.INCOTERMS] = model
  },
  [INCOTERMS_MANAGEMENT.MUTATIONS.CLEAR_INCOTERMS] (state) {
    state[INCOTERMS_MANAGEMENT.STATE.INCOTERMS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
